/* eslint-disable no-unused-vars */

import { Container, Divider, Typography, Grid2, useMediaQuery  } from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import badnorth from './screenshots/badnorth2.webp'
import islandstrains from './screenshots/islandstrains.jpg'
import UI from './screenshots/UI.png';
import newsettlement from './screenshots/newsettlement.gif'
import buildroads from './screenshots/buildroads.gif'
import routing from './screenshots/routing.gif';
import defend from './screenshots/defend.gif';
import disaster from './screenshots/disaster.gif';
import twod from './screenshots/2d.webp';
import shader from './screenshots/shader.png';
import threed from './screenshots/3d2.png';
import mockup from './screenshots/mockup.png';
import mood1 from './screenshots/nice1.png';
import mood2 from './screenshots/nice4.png';
import mood3 from './screenshots/nice5.png';
import now2d from './screenshots/2dnow.png';
import minimotorways from './screenshots/minimotorways.jpg';
import dorfromantik from './screenshots/dorfromantik.jpg';
import { Helmet } from 'react-helmet';
import tiles from './screenshots/tiles.png';
import tiles2 from './screenshots/tiles3.png';
import foam from './screenshots/foam.png';
import atmosphere from './screenshots/atmosphere.png';
import interactive from './screenshots/interactive.png';
import readable from './screenshots/readable.png';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff9727',
      contrastText: 'white',
    },
  },
});

const Surge = () => {
    const isMob = useMediaQuery('(max-width:1000px)');

    return <ThemeProvider theme={theme}>
        <Helmet>
            <title>More Bread Please - YZee Games</title>
            <meta name="description" content="Your kingdom teeters on the edge of disaster - only your trade routes can save it. More Bread Please is a thoughtful medieval strategy game about designing efficient trade routes to keep chaos at bay and your people fed. Not by conquest, but by connection." />
        </Helmet>
        <Container maxWidth="md">

            <Container sx={{paddingBottom:15, paddingTop:15}}>


            <Divider color='white'/>
            <Grid2 container justifyContent={'center'} alignItems={'center'}>
                <Typography align='center' fontFamily={'Metamorphous'} sx={{fontSize: 55, maxWidth:'md'}} color='white'>More Bread Please</Typography>
            </Grid2>
            <Divider color='white' sx={{marginBottom: 3}}/>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/l82xndA5LE0"
                    ></iframe>
                </div>
        
            <Typography align='center' fontFamily={'Patrick Hand'} sx={{fontSize: 26, marginTop: 3}} color='white'>Your kingdom teeters on the edge of disaster - only your trade routes can save it. More Bread Please is a thoughtful medieval strategy game about designing efficient trade routes to keep chaos at bay and your people fed. Not by conquest, but by connection.</Typography>
            
        </Container>
    </Container>

<Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30'}}>Features</Typography>
                </Grid2>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'#463c30', mt:3}} color='#463c30'>🗺️ Route Based Logistics</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', mb:2}}>
                    <li>Draw trade routes using wagons on land and ships on water</li>
                    <li>Transport essential resources like food, wood, stone, and gold</li>
                    <li>Optimise delivery networks to prevent starvation</li>
                </Typography>
                <img alt={"screenshot1"} src={routing} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'#463c30', mt:3}} color='#463c30'>🛠️ Build & Connect</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', mb:2}}>
                    <li>Construct roads, bridges, and forts</li>
                    <li>Upgrade infrastructure to boost efficiency and defence</li>
                    <li>Every few turns welcome new settlements into your trade network - each offering a key resource</li>
                </Typography>
                <img alt={"screenshot1"} src={newsettlement} style={{width:'100%', marginBottom:20}}></img>
                <img alt={"screenshot1"} src={buildroads} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'#463c30', mt:3}} color='#463c30'>⚔️ Defend Your Network</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', mb:2}}>
                    <li>React to barbarian invasions by positioning battalions and building forts</li>
                    <li>Battle resolution is turn-based and visible, adding strategic tension</li>
                    <li>Protect food routes or risk starvation and loss</li>
                </Typography>
                <img alt={"screenshot1"} src={defend} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'#463c30', mt:3}} color='#463c30'>🌊 Disaster & Environment Adaptation</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', mb:2}}>
                    <li>Survive floods and earthquakes that destroy settlements and break supply lines</li>
                    <li>Reroute and rebuild before your settlements starve</li>
                    <li>Each map presents a new geographic and resource puzzle, challenging you to navigate and adapt to rivers, waterfalls, cliffs, deserts, hills, and mountains</li>
                </Typography>
                <img alt={"screenshot1"} src={disaster} style={{width:'100%', marginBottom:30}}></img>

            </Grid2>
        </Container>
    </Container>





    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'#463c30'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white'}}>Art & Aesthetic</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', marginTop:3}}>
                    <li>Stylised 2D visuals inspired by Bad North, Dorfromantik, and Mini Motorways</li>
                    <li>Minimal textures and strong silhouettes to support strategic readability</li>
                    <li>Atmospheric environments with subtle animation, particles, and visual effects</li>
                    <li>Distinct terrain, resources, and settlement states readable at a glance</li>
                    <li>Elegant medieval inspired UI with a clean and accessible presentation</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', marginTop:5}}>Why The Art Style?</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', textAlign: 'left'}}>
                    <li>Strategy gameplay relies on quickly understanding terrain, routes, resources, and environmental threats</li>
                    <li>Stylised abstraction improves readability while reducing unnecessary visual clutter</li>
                    <li>Clear UI contrast and visual consistency help important gameplay information remain readable at a glance</li>
                    <li>The visual direction supports atmosphere and artistic identity without sacrificing gameplay clarity</li>
                    <li>A focused stylised approach allows the team to iterate rapidly and maintain a realistic production scope while prioritising polish over realism</li>
                </Typography>















                <Typography fontFamily="Metamorphous" sx={{ fontSize: 36.5, color: 'white', marginTop: 3, marginBottom: 2 }}>Target Quality - May 2027 Steam Demo</Typography>

                <Typography fontFamily="Patrick Hand" sx={{ fontSize: 27.5, color:'white', textAlign: 'left' }}>
                    The playable prototype establishes the game's core gameplay loop and mechanics. The target mockup establishes the intended readability, UI/UX, atmosphere and presentation standard for the May 2027 Steam demo. Target quality means the information required for strategic decisions is clear at a glance: terrain, routes, resources, settlement states and player actions remain easy to understand, while the world feels cohesive, responsive and alive.
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'white', marginTop:5}}>Current Playable Prototype</Typography>
                <img alt={"screenshot1"} src={now2d} style={{width:'100%'}}></img>


                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'white', marginTop:5}}>Steam Demo Target Quality</Typography>
                <img alt={"screenshot1"} src={tiles2} style={{width:'100%'}}></img>

                <Typography fontFamily="Patrick Hand" sx={{fontSize: 17, lineHeight: 1.3,  color: 'rgba(255, 255, 255, 0.72)',  textAlign: 'left',  marginTop: 1.5, fontStyle: 'italic'}}>
                    Target quality visualisation using AI assisted imagery to communicate the intended visual hierarchy, atmosphere and presentation quality. This is not final production artwork - final production artwork will be created and refined by lead 2D artist Victor Moore in collaboration with the team.
                </Typography>


{/* TARGET-QUALITY DETAIL BREAKDOWN */}
<Typography
    fontFamily="Metamorphous"
    sx={{ fontSize: 25, color: 'white', marginTop: 6, marginBottom: 2.5 }}
>
    Target Presentation Breakdown
</Typography>

<Grid2 container spacing={2}>
    <Grid2 size={{ xs: 12, md: 6 }}>
        <img
            alt="Environmental atmosphere target"
            src={atmosphere}
            style={{ width: '100%', height: 230, objectFit: 'cover', objectPosition: '50% 12%' }}
        />

        <Typography fontFamily="Metamorphous" sx={{ fontSize: 18, color: 'white', marginTop: 1.5 }}>
            Environmental Atmosphere
        </Typography>

        <Typography fontFamily="Patrick Hand" sx={{ fontSize: 20, lineHeight: 1.25, color: 'white', textAlign: 'left', marginTop: 1 }}>
            Animated birds, subtle cloud movement, drifting particles and terrain animation will add life and atmosphere to the world without obscuring gameplay.
        </Typography>
    </Grid2>

    <Grid2 size={{ xs: 12, md: 6 }}>
        <img
            alt="Terrain and shoreline presentation target"
            src={foam}
            style={{ width: '100%', height: 230, objectFit: 'cover', objectPosition: '78% 42%' }}
        />

        <Typography fontFamily="Metamorphous" sx={{ fontSize: 18, color: 'white', marginTop: 1.5 }}>
            Terrain and Shoreline Presentation
        </Typography>

        <Typography fontFamily="Patrick Hand" sx={{ fontSize: 20, lineHeight: 1.25, color: 'white', textAlign: 'left', marginTop: 1 }}>
            Refined terrain variation, shoreline foam and colour grading will create a more cohesive and atmospheric world.
        </Typography>
    </Grid2>

    <Grid2 size={{ xs: 12, md: 6 }}>
        <img
            alt="Route and transport readability target"
            src={readable}
            style={{ width: '100%', height: 230, objectFit: 'cover', objectPosition: '42% 54%' }}
        />

        <Typography fontFamily="Metamorphous" sx={{ fontSize: 18, color: 'white', marginTop: 1.5 }}>
            Route and Network Readability
        </Typography>

        <Typography fontFamily="Patrick Hand" sx={{ fontSize: 20, lineHeight: 1.25, color: 'white', textAlign: 'left', marginTop: 1 }}>
             Clear roads, numbered route indicators and delivery information will make complex trade networks easy to read at a glance.
        </Typography>
    </Grid2>

    <Grid2 size={{ xs: 12, md: 6 }}>
        <img
            alt="Settlement and interface clarity target"
            src={interactive}
            style={{ width: '100%', height: 230, objectFit: 'cover', objectPosition: '50% 82%' }}
        />

        <Typography fontFamily="Metamorphous" sx={{ fontSize: 18, color: 'white', marginTop: 1.5 }}>
            Settlement and Placement Feedback
        </Typography>

        <Typography fontFamily="Patrick Hand" sx={{ fontSize: 20, lineHeight: 1.25, color: 'white', textAlign: 'left', marginTop: 1 }}>
            Distinct settlement identities, clear selection states and readable placement feedback help players understand the effect and cost of their actions.
        </Typography>
    </Grid2>
</Grid2>


                <Typography fontFamily="Patrick Hand" sx={{ fontSize: 27.5, color:'white', textAlign: 'left', marginTop: 5, marginBottom: 3 }}>
                    This target will be reached through implementation and refinement of the readability and gameplay feedback features shown above, final UI animation and polish, creation and integration of the commissioned 2D asset set, and iterative playtesting and accessibility review ahead of the public demo.
                </Typography>











                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'white', marginTop:5}}>Mini Motorways</Typography>
                <img alt={"screenshot1"} src={minimotorways} style={{width:'100%'}}></img>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', textAlign: 'left'}}>
                    <li>Accessible strategy presentation without overwhelming UI</li>
                    <li>Readable route based gameplay with clean visual hierarchy for strategic clarity</li>
                    <li>Colour and silhouette driven abstraction</li>
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'white', marginTop:5}}>Bad North</Typography>
                <img alt={"screenshot1"} src={badnorth} style={{width:'100%'}}></img>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', textAlign: 'left'}}>
                    <li>Atmospheric stylisation with readable terrain and silhouettes</li>
                    <li>Minimal textures paired with strong environmental mood</li>
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'white', marginTop:5}}>Dorfromantik</Typography>
                <img alt={"screenshot1"} src={dorfromantik} style={{width:'100%'}}></img>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', textAlign: 'left'}}>
                    <li>Relaxed strategy presentation with minimal visual noise</li>
                </Typography>


            </Grid2>
        </Container>
    </Container>




    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>

                            <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30'}}>Sound & Atmosphere</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>
                    <li>A calm medieval atmosphere with moments of tension: nature sounds, peasant voices, wheels creaking, ambient disasters</li>
                    <li>Medieval themed soundtrack drawing from cultures during the middle ages</li>
                    <li>Sound reinforces gameplay states (danger, scarcity, relief)</li>
                    <li>The atmosphere aims to evoke togetherness, interconnection, and a living medieval world</li>
                </Typography>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/GGfttSfGbBM?start=56&autoplay=1&rel=0"
                    ></iframe>
                </div>
                
                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/K7ZqZVunCb4?start=147&autoplay=1&rel=0"
                    ></iframe>
                </div>

                                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/HVw_1RZncec?start=59&autoplay=1&rel=0"
                    ></iframe>
                </div>


                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/OxMQjlBq6zQ?start=6228&autoplay=1&rel=0"
                    ></iframe>
                </div>

            </Grid2>
        </Container>
    </Container>

    
    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white'}}>Diversity & Community Impact</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white'}}>
                    <li>Collaborating with charity Space2b to upskill migrant and refugee creatives and provide them with opportunities for visibility and professional growth</li>
                    <li>An emphasis on a multicultural team brings varied perspectives to development</li>
                    <li>UI and gameplay designed to be intuitive and inclusive, with features supporting players of all abilities</li>
                    <li>Fortified structures and soundtrack draw from global influences rather than relying solely on the Western European medieval styles commonly seen in the genre</li>
                </Typography>
                

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white', marginTop:8}}>Progress</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white'}}>
                    <li>Development started Jan 6, 2024</li>
                    <li>Core systems and gameplay loop are in place</li>
                    <li>Stylised 2D visual and audio direction established, with ongoing visual polish</li>
                    <li>Core UI layout and functionality are largely complete, with animation and final presentation polish remaining</li>
                    <li>Informal playtesting ongoing with friends and family</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white', marginTop:8}}>What's Changed Since Last Time</Typography>
                </Grid2>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white'}}>
                    <li>Extensive industry feedback incorporated from Brad Giblin, Mark Flanagan, and previous successful applicants - Rory Hulme (HappyHead), James Thomas (Barrel Smash), Matthew Jackson (Toot Games), and Oscar Brittain</li>
                    <li>Refined the project’s visual direction toward a stylised 2D presentation, establishing a clearer target quality focused on gameplay readability, abstraction, and strategic clarity</li>
                    <li>Established a clearer and more achievable production scope for the small team by building upon the game’s existing 2D foundation</li>
                    <li>Expanded technical and production documentation detailing the work required to reach the established target quality</li>
                    <li>Major development roadmap improvements, including expanded QA and playtesting phases and clearer, achievable production milestones informed by VicScreen feedback</li>
                </Typography>

                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white', marginTop:8}}>Funding Goals</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', textAlign: 'left'}}>
                    <li>Core Development Completion - finalising gameplay systems, refining balance and pacing, and polishing the game’s stylised 2D presentation, music, and sound</li>
                    <li>Diversity Initiatives - supporting inclusive world building and culturally diverse creative collaboration</li>
                    <li>Accessibility & Localisation - ensuring the game is playable by a broad audience across regions</li>
                    <li>QA & Playtesting - improving stability, fixing bugs, and refining the overall user experience</li>
                    <li>Steam Release & Publishing - packaging, optimising, and distributing the game for launch</li>
                    <li>Marketing & Outreach - raising awareness and engaging the strategy gaming community</li>
                </Typography>


            </Grid2>
        </Container>
    </Container>



    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Design Philosophy</Typography>
                </Grid2>

                <Typography
                fontFamily="Patrick Hand"
                sx={{ fontSize: 27.5, color: '#463c30', textAlign: 'left' }}
                >
                Our design philosophy focuses on accessibility and readability, creating a strategy game that’s easy to pick up in a genre often associated with complexity and overwhelming interfaces. Many games rely on dense HUDs and highly detailed worlds that, while immersive, make gameplay harder to read.<br /><br />
                More Bread Please takes a stylised and readable approach with clear UI, distinct terrain silhouettes, and visually simplified environments designed to support strategic clarity at a glance. The game’s atmospheric abstraction helps transform geography itself into the puzzle, allowing trade routes, settlements, and environmental challenges to remain visually distinct while maintaining a calm and cohesive world.
                </Typography>


            </Grid2>
        </Container>
    </Container>

    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white', marginTop:8}}>How Funding Gets Us There</Typography>
                </Grid2>

                <Typography
                fontFamily="Patrick Hand"
                sx={{ fontSize: 27.5, color: 'white', textAlign: 'left' }}
                >
                More Bread Please enters the funded period with its core gameplay loop, major gameplay systems and UI foundations already implemented. Funding can therefore focus on refining and balancing the strategy experience through extensive playtesting, alongside a defined set of production and polish work including final 2D assets and integration, environmental presentation, UI animation, audio, accessibility, localisation, QA and release preparation. These areas are broken down in detail across the Development Roadmap and supporting production documentation, including asset lists, QA and accessibility plans, and contractor quotes and estimates.<br/><br/>
                This focused production approach keeps the project achievable for a small team while delivering a clear, accessible, and strategically engaging experience for players. This project also serves as a unique platform and opportunity for a team of new and emerging creatives from diverse cultural and professional backgrounds to collaborate, grow, and showcase our skills.
                </Typography>


            </Grid2>
        </Container>
    </Container>

  </ThemeProvider>
}

export default Surge;